export type ComponentName = 'MyComponentName' | 'MyOtherComponentName';
